import { jsx, jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { Button, Classes, Dialog, Intent } from "@blueprintjs/core";
import { renderOnDoc } from "../utils/renderOnDoc";
import DialogFooter from "../DialogFooter";
export default function showConfirmationDialog(opts) {
  return new Promise((resolve) => {
    renderOnDoc((handleClose) => {
      return /* @__PURE__ */ jsx(AlertWrapper, { ...{ ...opts, handleClose, resolve } });
    });
  });
}
export class AlertWrapper extends Component {
  state = { isOpen: true };
  render() {
    const {
      title,
      handleClose,
      text,
      resolve,
      noCancelButton,
      content,
      className,
      thirdButtonNotMinimal,
      thirdButtonClassName,
      thirdButtonText,
      thirdButtonIntent,
      fourthButtonNotMinimal,
      fourthButtonClassName,
      fourthButtonText,
      fourthButtonIntent,
      handleSubmit,
      canEscapeKeyCancel,
      confirmButtonText = "OK",
      cancelButtonText = "Cancel",
      intent = Intent.PRIMARY,
      ...rest
    } = this.props;
    const doClose = (confirm) => {
      handleClose();
      this.setState({ isOpen: false });
      resolve(confirm);
    };
    return /* @__PURE__ */ jsxs(
      Dialog,
      {
        title,
        className: (title ? "" : "bp3-alert") + ` ${className || ""}`,
        isOpen: this.state.isOpen,
        intent,
        onClose: () => doClose(false),
        canEscapeKeyClose: canEscapeKeyCancel,
        cancelButtonText,
        onCancel: cancelButtonText ? () => doClose(false) : void 0,
        onConfirm: handleSubmit ? handleSubmit((v) => doClose(v)) : () => doClose(true),
        ...rest,
        ...noCancelButton && {
          onCancel: void 0,
          cancelButtonText: void 0
        },
        children: [
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: title ? "bp3-dialog-body" : "bp3-alert-contents",
              style: { padding: 5 },
              children: [
                content,
                text && /* @__PURE__ */ jsx("div", { style: { marginBottom: 10 }, children: text })
              ]
            }
          ),
          /* @__PURE__ */ jsx(
            DialogFooter,
            {
              ...{
                onBackClick: cancelButtonText && !noCancelButton ? () => doClose(false) : void 0,
                onClick: handleSubmit ? handleSubmit((v) => doClose(v)) : () => doClose(true),
                noCancel: true,
                additionalButtons: thirdButtonText || fourthButtonText ? /* @__PURE__ */ jsxs(React.Fragment, { children: [
                  !!fourthButtonText && /* @__PURE__ */ jsx(
                    Button,
                    {
                      className: (!fourthButtonNotMinimal ? Classes.MINIMAL : "") + " " + fourthButtonClassName,
                      intent: fourthButtonIntent,
                      text: fourthButtonText,
                      onClick: handleSubmit ? handleSubmit(
                        (v) => doClose({ ...v, fourthButtonClicked: true })
                      ) : () => doClose("fourthButtonClicked")
                    }
                  ),
                  !!thirdButtonText && /* @__PURE__ */ jsx(
                    Button,
                    {
                      className: (!thirdButtonNotMinimal ? Classes.MINIMAL : "") + " " + thirdButtonClassName,
                      intent: thirdButtonIntent,
                      text: thirdButtonText,
                      onClick: handleSubmit ? handleSubmit(
                        (v) => doClose({ ...v, thirdButtonClicked: true })
                      ) : () => {
                        doClose("thirdButtonClicked");
                      }
                    }
                  )
                ] }) : void 0,
                containerClassname: title ? "" : "bp3-alert-footer",
                backText: noCancelButton ? "" : cancelButtonText,
                text: confirmButtonText,
                intent
              }
            }
          )
        ]
      }
    );
  }
}
